export type UiLang = "es" | "en";

export const UI_LABELS: Record<UiLang, {
  modeTraductor: string;
  modeMinuta: string;
  from: string;
  to: string;
  minutaIn: string;
  start: string;
  stop: string;
  moreOptions: string;
  voiceOn: string;
  voiceOff: string;
  pip: string;
  docs: string;
  minuta: string;
  themeLight: string;
  themeDark: string;
  logout: string;
  uiLangLabel: string;
  modeAlert: string;
  profile: string;
  history: string;
}> = {
  es: {
    modeTraductor: "Traductor + Minuta",
    modeMinuta: "Solo Minuta",
    from: "DE",
    to: "A",
    minutaIn: "MINUTA EN",
    start: "Iniciar",
    stop: "Detener",
    moreOptions: "Más opciones",
    voiceOn: "Voz: Sí",
    voiceOff: "Voz: No",
    pip: "PiP",
    docs: "Docs",
    minuta: "Minuta",
    themeLight: "Tema claro",
    themeDark: "Tema oscuro",
    logout: "Cerrar sesión",
    uiLangLabel: "EN",
    modeAlert: "Por favor, detén la sesión antes de cambiar de modo.",
    profile: "Mi Perfil",
    history: "Historial",
  },
  en: {
    modeTraductor: "Translator + Minutes",
    modeMinuta: "Minutes Only",
    from: "FROM",
    to: "TO",
    minutaIn: "MINUTES IN",
    start: "Start",
    stop: "Stop",
    moreOptions: "More options",
    voiceOn: "Voice: On",
    voiceOff: "Voice: Off",
    pip: "PiP",
    docs: "Docs",
    minuta: "Minutes",
    themeLight: "Light mode",
    themeDark: "Dark mode",
    logout: "Log out",
    uiLangLabel: "ES",
    modeAlert: "Please stop the session before switching mode.",
    profile: "My Profile",
    history: "History",
  },
};
